// src/pages/Transporte.jsx
import Cargando from "../components/Cargando";
import React, { useState, useMemo } from "react";
import { useProveedores } from "../hooks/useProveedores";
import { alertaMantenimiento } from "../utils/whatsapp";

const TIPOS  = ["Camión 5T", "Camión 10T", "Camión 20T", "Camioneta", "Externo"];
const INICIAL = { nombre: "", placa: "", tipo: "Camión 10T", conductor: "", telefonoConductor: "", capacidadTon: "", proximoMantenimiento: "", notas: "", estado: "Disponible" };

const ESTADO_STYLE = {
  "Disponible":   { bg: "#d1fae5", color: "#065f46", border: "#1D9E75" },
  "En ruta":      { bg: "#fef3c7", color: "#d97706", border: "#D97706" },
  "Mantenimiento":{ bg: "#fee2e2", color: "#991b1b", border: "#DC2626" },
};

const lbl = { display: "block", fontSize: 11, fontWeight: 600, color: "#475569", marginBottom: 5 };
const inp = { width: "100%", padding: "9px 12px", border: "1px solid #e2e8f0", borderRadius: 8, fontSize: 13, color: "#1e293b", outline: "none", background: "#fff", fontFamily: "inherit", boxSizing: "border-box" };
const sel = { ...inp, cursor: "pointer" };

export default function Transporte() {
  const { proveedores: flota, loading, crear, actualizar, eliminar } = useProveedores("transporte");

  const [form,       setForm]       = useState(INICIAL);
  const [mostrar,    setMostrar]    = useState(false);
  const [editId,     setEditId]     = useState(null);
  const [busqueda,   setBusqueda]   = useState("");
  const [filtroEst,  setFiltroEst]  = useState("Todos");
  const [confirmDel, setConfirmDel] = useState(null);

  const handleChange = e => setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (editId) { await actualizar(editId, form); setEditId(null); }
    else await crear(form);
    setForm(INICIAL); setMostrar(false);
  };

  const editar = (v) => { setForm({ ...INICIAL, ...v }); setEditId(v.id); setMostrar(true); };

  const diasHasta = (fecha) => {
    if (!fecha) return null;
    const [y, m, d] = String(fecha).split("-").map(Number);
    const hoy = new Date(); hoy.setHours(0, 0, 0, 0);
    const f   = new Date(y, m - 1, d);
    return Math.round((f - hoy) / 86400000);
  };

  const flotaFiltrada = useMemo(() => {
    let lista = [...flota];
    if (filtroEst !== "Todos") lista = lista.filter(v => v.estado === filtroEst);
    if (busqueda) {
      const b = busqueda.toLowerCase();
      lista = lista.filter(v =>
        v.nombre?.toLowerCase().includes(b) ||
        v.placa?.toLowerCase().includes(b) ||
        v.conductor?.toLowerCase().includes(b)
      );
    }
    return lista;
  }, [flota, filtroEst, busqueda]);

  const kpis = useMemo(() => ({
    total:         flota.length,
    disponibles:   flota.filter(v => v.estado === "Disponible").length,
    enRuta:        flota.filter(v => v.estado === "En ruta").length,
    mantenimiento: flota.filter(v => v.estado === "Mantenimiento").length,
    alertas:       flota.filter(v => { const d = diasHasta(v.proximoMantenimiento); return d !== null && d <= 7 && d >= 0; }).length,
  }), [flota]);

  if (loading) return <Cargando />;

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>

      {/* Header */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 10 }}>
        <h1 style={{ fontSize: 22, fontWeight: 700, color: "#1e293b" }}>Transporte y flota</h1>
        <button onClick={() => { setMostrar(!mostrar); setEditId(null); setForm(INICIAL); }}
          style={{ background: "#1e3a5f", color: "#fff", border: "none", borderRadius: 8, padding: "8px 18px", fontSize: 13, fontWeight: 600, cursor: "pointer" }}>
          {mostrar ? "Cancelar" : "+ Agregar vehículo"}
        </button>
      </div>

      {/* KPIs */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(5, 1fr)", gap: 10 }}>
        {[
          { label: "Total flota",           valor: kpis.total,         border: "#3A3C7A" },
          { label: "Disponibles",           valor: kpis.disponibles,   border: "#1D9E75", sub: "listos para salir",  subColor: "#1D9E75" },
          { label: "En ruta",               valor: kpis.enRuta,        border: "#D97706", sub: "en tránsito",        subColor: "#D97706" },
          { label: "En mantenimiento",      valor: kpis.mantenimiento, border: "#DC2626", sub: "no disponibles",     subColor: "#DC2626" },
          { label: "Alertas mantenimiento", valor: kpis.alertas,       border: kpis.alertas > 0 ? "#DC2626" : "#1D9E75", sub: kpis.alertas > 0 ? "próximos 7 días" : "sin alertas", subColor: kpis.alertas > 0 ? "#DC2626" : "#1D9E75" },
        ].map(k => (
          <div key={k.label} className="kpi-card card-lift" style={{ background: "#fff", border: "0.5px solid #e8ecf3", borderTop: `3px solid ${k.border}`, borderRadius: 12, padding: "14px 16px" }}>
            <div style={{ fontSize: 10, color: "#64748b", marginBottom: 4, fontWeight: 500 }}>{k.label}</div>
            <div style={{ fontSize: 22, fontWeight: 800, color: "#1e293b", letterSpacing: "-0.5px" }}>{k.valor}</div>
            {k.sub && <div style={{ fontSize: 10, marginTop: 4, color: k.subColor, fontWeight: 500 }}>{k.sub}</div>}
          </div>
        ))}
      </div>

      {/* Formulario */}
      {mostrar && (
        <form onSubmit={handleSubmit} style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 12, padding: 20 }}>
          <p style={{ fontSize: 12, fontWeight: 700, color: "#2563eb", marginBottom: 14, textTransform: "uppercase", letterSpacing: "0.06em" }}>
            {editId ? "Editar vehículo" : "Nuevo vehículo / transportista"}
          </p>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}>
            <div><label style={lbl}>Nombre / Empresa *</label><input name="nombre" value={form.nombre} onChange={handleChange} required placeholder="Ej: Transp. Rápido SAC" style={inp} /></div>
            <div><label style={lbl}>Placa</label><input name="placa" value={form.placa} onChange={handleChange} placeholder="RHC-845" style={inp} /></div>
            <div><label style={lbl}>Tipo</label><select name="tipo" value={form.tipo} onChange={handleChange} style={sel}>{TIPOS.map(t => <option key={t}>{t}</option>)}</select></div>
            <div><label style={lbl}>Capacidad (toneladas)</label><input name="capacidadTon" type="number" value={form.capacidadTon} onChange={handleChange} placeholder="10" style={inp} /></div>
            <div><label style={lbl}>Conductor</label><input name="conductor" value={form.conductor} onChange={handleChange} placeholder="Pedro Salinas" style={inp} /></div>
            <div><label style={lbl}>Teléfono conductor</label><input name="telefonoConductor" value={form.telefonoConductor} onChange={handleChange} placeholder="987-654-321" style={inp} /></div>
            <div><label style={lbl}>Estado</label><select name="estado" value={form.estado} onChange={handleChange} style={sel}>{["Disponible", "En ruta", "Mantenimiento"].map(s => <option key={s}>{s}</option>)}</select></div>
            <div><label style={lbl}>Próximo mantenimiento</label><input name="proximoMantenimiento" type="date" value={form.proximoMantenimiento} onChange={handleChange} style={inp} /></div>
            <div style={{ gridColumn: "1/-1" }}><label style={lbl}>Notas</label><textarea name="notas" value={form.notas} onChange={handleChange} rows={2} style={{ ...inp, resize: "vertical" }} placeholder="Rutas habituales, capacidades especiales..." /></div>
          </div>
          <div style={{ display: "flex", gap: 10, marginTop: 14 }}>
            <button type="submit" style={{ flex: 1, padding: "10px 0", background: "#1e3a5f", color: "#fff", border: "none", borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: "pointer" }}>
              {editId ? "Guardar cambios" : "Agregar"}
            </button>
            <button type="button" onClick={() => { setMostrar(false); setEditId(null); }} style={{ padding: "10px 18px", border: "1px solid #e2e8f0", borderRadius: 8, background: "#fff", fontSize: 13, cursor: "pointer", color: "#475569" }}>
              Cancelar
            </button>
          </div>
        </form>
      )}

      {/* Filtros */}
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
        <input
          placeholder="Buscar por nombre, placa, conductor..."
          value={busqueda} onChange={e => setBusqueda(e.target.value)}
          style={{ flex: 1, minWidth: 200, padding: "7px 12px", border: "1px solid #e2e8f0", borderRadius: 8, fontSize: 13, outline: "none" }}
        />
        <div style={{ display: "flex", gap: 4 }}>
          {["Todos", "Disponible", "En ruta", "Mantenimiento"].map(e => {
            const on  = filtroEst === e;
            const est = ESTADO_STYLE[e];
            return (
              <button key={e} onClick={() => setFiltroEst(e)} style={{
                padding: "5px 12px", borderRadius: 8, fontSize: 11, fontWeight: 500, border: "none", cursor: "pointer",
                background: on ? (est?.color || "#1E3A5F") : "#f1f5f9",
                color:      on ? "#fff" : "#64748b",
              }}>{e}</button>
            );
          })}
        </div>
      </div>

      {/* Lista de flota */}
      <div style={{ display: "grid", gap: 10 }}>
        {flotaFiltrada.length === 0 ? (
          <div style={{ textAlign: "center", padding: 40, color: "#94a3b8", background: "#fff", borderRadius: 12, border: "1px solid #e2e8f0" }}>
            {flota.length === 0 ? "Sin vehículos registrados. Agrega el primero." : "No se encontraron vehículos."}
          </div>
        ) : flotaFiltrada.map((v, i) => {
          const dias   = diasHasta(v.proximoMantenimiento);
          const estilo = ESTADO_STYLE[v.estado] || ESTADO_STYLE["Disponible"];
          const alertaRoja = dias !== null && dias <= 3;
          return (
            <div key={v.id} className="stagger-item card-lift" style={{ animationDelay: `${Math.min(i * 60, 360)}ms`, background: "#fff", border: `1px solid ${alertaRoja ? "#fca5a5" : "#e8ecf3"}`, borderRadius: 12, padding: 16, display: "flex", alignItems: "center", gap: 16, flexWrap: "wrap" }}>
              {/* Icono */}
              <div style={{ width: 44, height: 44, borderRadius: "50%", background: "#eff6ff", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 20, flexShrink: 0 }}>🚚</div>

              {/* Info principal */}
              <div style={{ flex: 1, minWidth: 180 }}>
                <div style={{ fontWeight: 700, color: "#1e293b", fontSize: 14 }}>{v.placa ? `${v.placa} — ` : ""}{v.nombre}</div>
                <div style={{ fontSize: 11, color: "#64748b" }}>
                  {v.tipo}{v.capacidadTon ? ` · ${v.capacidadTon}T` : ""}{v.conductor ? ` · ${v.conductor}` : ""}
                </div>
                {v.notas && <div style={{ fontSize: 10, color: "#94a3b8", marginTop: 2, fontStyle: "italic" }}>{v.notas}</div>}
              </div>

              {/* Estado badge */}
              <span style={{ fontSize: 11, fontWeight: 600, padding: "4px 10px", borderRadius: 10, background: estilo.bg, color: estilo.color }}>
                {v.estado}
              </span>

              {/* Mantenimiento */}
              {dias !== null && (
                <div style={{ fontSize: 11, textAlign: "center", minWidth: 90 }}>
                  <div style={{ color: dias < 0 ? "#dc2626" : dias <= 7 ? "#d97706" : "#64748b", fontWeight: 600 }}>
                    {dias < 0 ? `Vencido ${Math.abs(dias)}d` : dias === 0 ? "Hoy" : `En ${dias}d`}
                  </div>
                  <div style={{ color: "#94a3b8", fontSize: 10 }}>Mantenimiento</div>
                </div>
              )}

              {/* Acciones */}
              <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                {v.telefonoConductor && (
                  <button onClick={() => window.open(`https://wa.me/51${v.telefonoConductor.replace(/\D/g, "")}`, "_blank")}
                    style={{ fontSize: 11, padding: "5px 10px", borderRadius: 6, background: "#dcf8c6", color: "#128c7e", border: "none", cursor: "pointer", fontWeight: 600 }}>
                    WhatsApp
                  </button>
                )}
                {dias !== null && dias <= 7 && dias >= 0 && (
                  <button onClick={() => alertaMantenimiento(v, dias)}
                    style={{ fontSize: 11, padding: "5px 10px", borderRadius: 6, background: "#fef3c7", color: "#d97706", border: "none", cursor: "pointer", fontWeight: 600 }}>
                    ⚠ Alertar
                  </button>
                )}
                {/* Cambio rápido de estado */}
                <select
                  value={v.estado}
                  onChange={e => actualizar(v.id, { estado: e.target.value })}
                  style={{ fontSize: 11, padding: "5px 8px", borderRadius: 6, border: `1px solid ${estilo.color}`, background: estilo.bg, color: estilo.color, cursor: "pointer", outline: "none" }}
                >
                  {["Disponible", "En ruta", "Mantenimiento"].map(s => <option key={s}>{s}</option>)}
                </select>
                <button onClick={() => editar(v)}
                  style={{ fontSize: 11, padding: "5px 10px", borderRadius: 6, background: "#dbeafe", color: "#1d4ed8", border: "none", cursor: "pointer", fontWeight: 600 }}>
                  Editar
                </button>
                {confirmDel === v.id ? (
                  <>
                    <button onClick={() => { eliminar(v.id); setConfirmDel(null); }} style={{ fontSize: 11, padding: "5px 10px", borderRadius: 6, background: "#DC2626", color: "#fff", border: "none", cursor: "pointer", fontWeight: 600 }}>Sí</button>
                    <button onClick={() => setConfirmDel(null)} style={{ fontSize: 11, padding: "5px 9px", borderRadius: 6, background: "#f1f5f9", color: "#475569", border: "none", cursor: "pointer" }}>No</button>
                  </>
                ) : (
                  <button onClick={() => setConfirmDel(v.id)}
                    style={{ fontSize: 11, padding: "5px 10px", borderRadius: 6, background: "#FCEBEB", color: "#A32D2D", border: "none", cursor: "pointer", fontWeight: 600 }}>
                    Del
                  </button>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
